import type { Listing, ListingImage, ModelFind, TokenUser } from '~/models'
import { UserGroup, UserRole } from '~/models'
import { checkUserGroup } from './permissions'

export function getUserListingsFind(
  user: TokenUser,
  organizationId: string
): ModelFind {
  const find: ModelFind = {
    'organization._id': organizationId,
  }

  if (checkUserGroup(UserGroup.organizationAdmin, user)) {
    return find
  }

  if (
    checkUserGroup(UserGroup.companyAdmin, user) ||
    user.role === UserRole.appraiser
  ) {
    const companyQuery =
      user?.company?.childCompanyIds && user.company.childCompanyIds.length > 0
        ? {
            $in: user.company.childCompanyIds.concat(user.company._id),
          }
        : { $in: [user!.company?._id] }

    if (
      user.role === UserRole.managingBroker ||
      user.role === UserRole.broker
    ) {
      find['$or'] = [
        {
          'brokers._id': user._id,
        },
        {
          'company._id': companyQuery,
        },
      ]
    } else {
      find['company._id'] = companyQuery
    }
  } else {
    find['brokers._id'] = user._id
  }

  return find
}

export function isWatermarkedImage(image: ListingImage) {
  return (
    !!image.isWatermarked ||
    image.url === 'watermarked' ||
    image.thumbUrl === 'watermarked' ||
    image.url.length === 0 ||
    image.thumbUrl.length === 0
  )
}

export function removeWatermarkedImages<T extends Partial<Listing>>(
  listing: T
) {
  if (!listing.images || listing.images.length === 0) return listing

  const images = listing.images
    .filter((image) => {
      return isWatermarkedImage(image) ? undefined : image
    })
    .filter((image) => image !== undefined)

  listing.images = images

  return listing
}
